export const OWNER = {
    id: 1,
    name: 'Owner',
};

export const OCCUPANT = {
    id: 2,
    name: 'Occupant',
};

export const MANAGER = {
    id: 3,
    name: 'Manager',
};

export const OWNER_OCCUPIER = {
    id: 4,
    name: 'Owner occupier',
};

export const LANDLORD = {
    id: 5,
    name: 'Landlord',
};

export const FREEHOLDER = {
    id: 6,
    name: 'Freeholder',
};

export const LEASEHOLDER = {
    id: 7,
    name: 'Leaseholder',
};

export const TENANT = {
    id: 8,
    name: 'Tenant',
};

export const OTHER_OCCUPANT = {
    id: 9,
    name: 'Other occupant',
};

export const CONTACT_TYPES = [
    MANAGER,
    OWNER_OCCUPIER,
    LANDLORD,
    FREEHOLDER,
    LEASEHOLDER,
    TENANT,
    OTHER_OCCUPANT,
];
